import moment from 'moment';
import { OPEN_ITEM_STATUS } from 'domain/open-item';

/**
 * Shared by the Open Items table (DATE DUE cell) and the Open Item details
 * view (Due Date field): a due date only reads as "overdue" when it is
 * strictly before today (today itself is not overdue, and an item with no
 * due date is never overdue) AND the item hasn't already been closed out.
 * "Closed out" is checked two ways on purpose -- the legacy `resolved`
 * boolean and the newer `status` field (see domain/open-item.js) -- because
 * backfilled/older records set `resolved` without necessarily keeping
 * `status` in lockstep going forward.
 */
export const isOpenItemOverdue = (openItem) => {
  if (!openItem || !openItem.resolve_by) return false;
  if (openItem.resolved || openItem.status === OPEN_ITEM_STATUS.COMPLETED)
    return false;
  return moment(openItem.resolve_by).isBefore(moment(), 'day');
};
